import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router";
import ErrorMessage from "../../components/ErrorMessage";
import FormInput from "../../components/FormInput";
import FormLabel from "../../components/FormLabel";
import SimpleButton from "../../components/SimpleButton";
import Spacer from "../../components/Spacer";
import { IApplicationState } from "../../store";
import { itemNameDraftUpdate,itemsNamesSaveRequest } from "../../store/itemsNames/slice";
import { IItemName } from "../../store/itemsNames/types";
import { Container } from "./styles";

const ItemNameForm: React.FC = (props) => {
    const route = useMatch("/name/:idName/form");

    const { t } = useTranslation();

    const idItemName = route?.params.idName;

    const itemName = useSelector((state: IApplicationState) => state.itemsNames.data.find((itemName) => itemName.id === idItemName));

    const itemsNames = useSelector((state: IApplicationState) => state.itemsNames);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingItemName = itemsNames.draftItemName;

    const setEditingItemName = useCallback((itemName: IItemName) => {
        dispatch(itemNameDraftUpdate(itemName));
    },[dispatch]);

    useEffect(() => {
        if (itemName && !isLoaded) {
            setEditingItemName({
            ...itemName,
            error: undefined,
            });
        setIsLoaded(true);
        }
    },[itemName, isLoaded, setEditingItemName]);

    if (!editingItemName) {
        return (
            <Container>
                <h1>{t("pages.items_names.not_found_form")}</h1>
            </Container>
        );
    }

    return (
        <Container>
        <h1>
            {editingItemName.id ? t("pages.items_names.edit_name") : t("pages.items_names.create_name")}
        </h1>

        <FormLabel>{t("pages.items_names.name_name")}</FormLabel>
        <FormInput
            value={editingItemName?.name || ""}
            onChangeText={(text) => {
                setEditingItemName({
                    ...editingItemName,
                    name: text
                });
            }}
        />

        <Spacer size={20} />

        <SimpleButton
            prependIcon="save"
            color="primary"
            disabled={editingItemName?.isSaving || itemsNames.isLoading}
            onClick={() => {
                dispatch(itemsNamesSaveRequest(editingItemName));
            }}
        >
            {editingItemName?.isSaving ? `${t("common.buttons.saving")}...`: t("common.buttons.save")}

        </SimpleButton>

        <Spacer size={20} />

        {editingItemName?.error && <React.Fragment>
            <ErrorMessage>{editingItemName.error.message}</ErrorMessage>
            <Spacer size={20} />
            </React.Fragment>}
        </Container>
    );
};

export default ItemNameForm;